export { LinkButton as default } from './LinkButton';
